import type { GameDef } from '../registry';
import { luOrLabuDef } from './def';
import { mountLuOrLabu } from './view';

export const luOrLabu: GameDef = { ...luOrLabuDef, mount: mountLuOrLabu };
